<template>
  <div class="side-open-app" @click="button">
    <OpenApp :unitKey="unitKey" :options="options" :appendParam="appendParam">
      <div class="button">APP内打开</div>
    </OpenApp>
  </div>
</template>

<script>
import OpenApp from './OpenApp.vue'

export default {
  props: {
    unitKey: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default: {},
    },
    appendParam: {
      type: Object,
      default: null,
    }, //安卓 额外参数
  },
  methods: {
    button() {
      this.$emit('onButton')
    },
  },
  components: { OpenApp },
}
</script>

<style lang="scss" scoped>
.side-open-app {
  position: fixed;
  right: 0;
  bottom: 2.6rem;
  z-index: 10;
}

.button {
  @include flex_center;
  width: 2.4rem;
  height: 0.88rem;
  background: #ffffff;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  border-radius: 17px 0px 0px 17px;
  font-size: 0.32rem;
  color: var(--main-color);
  font-weight: bold;
}
</style>
